// extracted by mini-css-extract-plugin
export default {"passList":"pass-list_passList__jfJ5n","noPassesText":"pass-list_noPassesText__+HWbv","heading":"pass-list_heading__uLNYn","addPassButton":"pass-list_addPassButton__1lo+D"};